import http from "../http-common";
import authHeader from '../auth-header';

export default class DashboardService {

    consultarDashboard(usuario){
        return http.get("jaapzproceso/dashboard/consultarDashboard/" + usuario, { headers: authHeader() });
    }

}